export const dict = {
  // 调价申请状态
  ajustStatus: [
    { label: '待审批', value: 0 },
    { label: '已撤销', value: 1 },
    { label: '已拒绝', value: 2 },
    { label: '待生效', value: 3 },
    { label: '已生效', value: 4 },
  ],
  // 提现记录状态
  withdrawStatus: [
    { label: '待处理', value: 0 },
    { label: '待付款', value: 1 },
    { label: '付款中', value: 2 },
    { label: '提现成功', value: 3 },
    { label: '提现失败', value: 4 }
  ]
}

export default dict
